import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader, ModalFooter} from 'reactstrap';
import {Switch} from "../buttons/Swtich";
import {
    CURRENCY_COLUMN,
    CURRENT_PERIOD_TIME_COMPLETION_COLUMN,
    LABELS_COLUMN,
    NAMES_FOR_FUNDS_COLUMN_SECTIONS,
    NAMES_FOR_BUDGET_COLUMNS_SECTIONS,
    NAMES_FOR_CONVERSIONS_COLUMNS_SECTIONS,
    NAMES_FOR_TODAY_COLUMNS_SECTIONS,
    GOAL_1_COLUMN,
    GOAL_2_COLUMN,
    COMMENTS_COLUMN, CURRENT_PERIOD_PERIOD_DATES_COLUMN, GOAL_1_INFO_COLUMN, GOAL_2_INFO_COLUMN,
    CAMPAIGN_STATUS_COLUMN,
    getColumnData
} from "./columns";
import {ActiveColumnsList} from "./ActiveColumnsList";
import {FaIcon} from "../FaIcon";
import { withTranslation } from 'react-i18next';
import {toast} from 'react-toastify';
import {
    renderViewSelector,
    renderActionButtons,
    renderSearchBar,
    renderError
} from '../shared/ColumnsSelectorModalHelpers';
import {encodeColumnsToUrl} from "../../utils/DashboardColumnsUrlParams";

class ConfigColumnsModalComponent extends Component {

    constructor(props) {
        super(props);
        
        // Usar activeColumnsSetId si está disponible, sino detectar por comparación
        const activeView = props.activeColumnsSetId !== null && props.activeColumnsSetId !== undefined
            ? props.activeColumnsSetId
            : this.detectActiveView(props.activeColumns, props.columnsSets);
        
        this.state = {
            searchQuery: "",
            activeColumns: [...(props.activeColumns || [])],
            activeView: activeView, // ID del set activo o null si es personalizado
            hasUnsavedChanges: false,
            originalColumns: [...(props.activeColumns || [])],
            collapsedSections: {}, // Para controlar qué secciones están colapsadas
            showSaveAsInput: false,
            newSetName: "",
            isSaving: false,
        };
        this.isInitialMount = true;
        
        this.handleChange = this.handleChange.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleColumnsPositionChange = this.handleColumnsPositionChange.bind(this);
        this.handleColumnRemove = this.handleColumnRemove.bind(this);
        this.handleApply = this.handleApply.bind(this);
        this.handleSaveView = this.handleSaveView.bind(this);
        this.handleUpdateView = this.handleUpdateView.bind(this);
        this.handleSaveAsNew = this.handleSaveAsNew.bind(this);
        this.handleCancelSave = this.handleCancelSave.bind(this);
        this.handleViewSelect = this.handleViewSelect.bind(this);
        this.toggleSection = this.toggleSection.bind(this);
        this.handleNewSetNameChange = this.handleNewSetNameChange.bind(this);
        this.handleCopyColumnsLink = this.handleCopyColumnsLink.bind(this);
        this.column_data_by_id = {};
    }

    /**
     * Detecta qué set de columnas coincide exactamente con las columnas activas
     * @param {Array} activeColumns - Columnas actualmente activas
     * @param {Object} columnsSets - Objeto con todos los sets de columnas (clave: ID, valor: {id, name, columns})
     * @returns {number|string|null} - ID del set activo o null si no hay coincidencia
     */
    detectActiveView(activeColumns, columnsSets) {
        if (!activeColumns || !columnsSets || activeColumns.length === 0) {
            return null;
        }

        // Buscar en todos los sets si alguno coincide exactamente
        for (const setId in columnsSets) {
            const set = columnsSets[setId];
            const setColumns = set && set.columns ? set.columns : (Array.isArray(set) ? set : []);
            
            // Comparar arrays: deben tener la misma longitud y los mismos elementos en el mismo orden
            if (activeColumns.length === setColumns.length) {
                const matches = activeColumns.every((val, index) => val === setColumns[index]);
                if (matches) {
                    return setId;
                }
            }
        }

        return null;
    }

    componentDidUpdate(prevProps) {
        // Cuando el modal se abre, usar activeColumnsSetId si está disponible
        if (!prevProps.isOpen && this.props.isOpen) {
            const activeView = this.props.activeColumnsSetId !== null && this.props.activeColumnsSetId !== undefined
                ? this.props.activeColumnsSetId
                : this.detectActiveView(this.props.activeColumns, this.props.columnsSets);
            this.setState({
                activeColumns: [...(this.props.activeColumns || [])],
                originalColumns: [...(this.props.activeColumns || [])],
                activeView: activeView,
                hasUnsavedChanges: false,
            });
        }
        // Actualizar si las columnas activas o el ID del set activo cambian desde fuera del modal
        else if ((prevProps.activeColumns !== this.props.activeColumns || 
                  prevProps.activeColumnsSetId !== this.props.activeColumnsSetId) && 
                 !this.isInitialMount) {
            const activeView = this.props.activeColumnsSetId !== null && this.props.activeColumnsSetId !== undefined
                ? this.props.activeColumnsSetId
                : this.detectActiveView(this.props.activeColumns, this.props.columnsSets);
            this.setState({
                activeColumns: [...(this.props.activeColumns || [])],
                originalColumns: [...(this.props.activeColumns || [])],
                activeView: activeView,
                hasUnsavedChanges: false,
            });
        }
        this.isInitialMount = false;
    }

    componentDidMount() {
        // Inicializar todas las secciones como expandidas
        const sections = this.getAllSectionNames();
        const collapsedSections = {};
        sections.forEach(section => {
            collapsedSections[section] = false;
        });
        this.setState({ collapsedSections });
    }

    getAllSectionNames() {
        const { t } = this.props;
        return [
            t('config_columns_modal.goals'),
            t('config_columns_modal.today'),
            t('config_columns_modal.budget'),
            t('config_columns_modal.conversions'),
            t('config_columns_modal.available_funds'),
            t('config_columns_modal.this_period'),
            'GA4',
            'Ecommerce',
            t('config_columns_modal.attributes'),
        ];
    }

    handleSearchChange(event) {
        this.setState({ searchQuery: event.target.value });
    }

    handleChange(event) {
        const target = event.target;
        const name = target.name;
        const isChecked = target.checked;

        this.setState(prevState => {
            let newActiveColumns;
            if (isChecked) {
                newActiveColumns = [...prevState.activeColumns, name];
            } else {
                newActiveColumns = prevState.activeColumns.filter(col => col !== name);
            }

            const hasChanges = !this.arraysEqual(newActiveColumns, prevState.originalColumns);
            return {
                activeColumns: newActiveColumns,
                hasUnsavedChanges: hasChanges && prevState.activeView !== null,
            };
        });
    }

    handleColumnsPositionChange(newOrder) {
        this.setState(prevState => {
            const hasChanges = !this.arraysEqual(newOrder, prevState.originalColumns);
            return {
                activeColumns: newOrder,
                hasUnsavedChanges: hasChanges && prevState.activeView !== null,
            };
        });
    }

    handleColumnRemove(columnId) {
        this.setState(prevState => {
            const newActiveColumns = prevState.activeColumns.filter(col => col !== columnId);
            const hasChanges = !this.arraysEqual(newActiveColumns, prevState.originalColumns);
            return {
                activeColumns: newActiveColumns,
                hasUnsavedChanges: hasChanges && prevState.activeView !== null,
            };
        });
    }

    arraysEqual(arr1, arr2) {
        if (arr1.length !== arr2.length) return false;
        return arr1.every((val, index) => val === arr2[index]);
    }

    handleViewSelect(event) {
        const selectedViewId = event.target.value;
        if (selectedViewId === "" || selectedViewId === "custom") {
            // Vista personalizada - mantener las columnas actuales
            this.setState({
                activeView: null,
                hasUnsavedChanges: false,
                originalColumns: [...this.state.activeColumns],
            });
        } else {
            // Cargar vista guardada
            const set = this.props.columnsSets[selectedViewId];
            const selectedColumns = set && set.columns ? set.columns : [];
            this.setState({
                activeView: selectedViewId,
                activeColumns: [...selectedColumns],
                originalColumns: [...selectedColumns],
                hasUnsavedChanges: false,
            });
        }
    }

    handleApply() {
        // Si hay un set de columnas seleccionado y no ha sido modificado, aplicar el set completo
        if (this.state.activeView && !this.state.hasUnsavedChanges && this.props.onSelectColumnSet) {
            // Aplicar el set seleccionado usando applyColumnSet
            this.props.onSelectColumnSet(this.state.activeView);
            this.props.onClose();
        } else {
            // Si no hay set seleccionado o hay cambios sin guardar, actualizar columnas individualmente
            const currentColumns = this.state.activeColumns;
            // Actualizar cada columna individualmente si es necesario
            const propsColumns = this.props.activeColumns || [];
            
            // Agregar columnas nuevas
            currentColumns.forEach(colId => {
                if (!propsColumns.includes(colId)) {
                    this.props.handleColumnStateChange(colId, true);
                }
            });
            
            // Remover columnas que ya no están
            propsColumns.forEach(colId => {
                if (!currentColumns.includes(colId)) {
                    this.props.handleColumnStateChange(colId, false);
                }
            });
            
            // Actualizar el orden
            this.props.onColumnsPositionChange(currentColumns);
            this.props.onClose();
        }
    }

    handleSaveView() {
        const { t } = this.props;
        if (!this.state.newSetName.trim()) {
            alert(t('config_columns_modal.set_name_required', 'El nombre del set es requerido'));
            return;
        }

        this.setState({ isSaving: true });
        // Crear nuevo set (sin ID, el backend lo asignará)
        // onSaveColumnSet ahora devuelve una Promise, así que esperamos la respuesta
        const savePromise = this.props.onSaveColumnSet(null, this.state.newSetName, this.state.activeColumns);
        
        if (savePromise && typeof savePromise.then === 'function') {
            savePromise
                .then((savedSet) => {
                    // El set se guardó, ahora aplicar el set usando applyColumnSet
                    const savedSetId = savedSet && savedSet.id ? savedSet.id : null;
                    
                    // Aplicar el set guardado como activo usando onSelectColumnSet (que llama a applyColumnSet)
                    if (savedSetId && this.props.onSelectColumnSet) {
                        this.props.onSelectColumnSet(savedSetId);
                    }
                    
                    this.setState({
                        isSaving: false,
                        showSaveAsInput: false,
                        newSetName: "",
                        activeView: savedSetId, // Actualizar activeView con el ID del set guardado
                        originalColumns: [...this.state.activeColumns],
                        hasUnsavedChanges: false,
                    });
                    // El alert se muestra desde Dashboard.js si hay error
                    // Si todo salió bien, el set ya está aplicado y activo
                })
                .catch(() => {
                    // El error ya se maneja en Dashboard.js
                    this.setState({ isSaving: false });
                });
        } else {
            // Fallback para compatibilidad si onSaveColumnSet no devuelve una Promise
            alert(t('config_columns_modal.column_set_saved_successfully'));
            const tempId = Date.now();
            this.setState({
                isSaving: false,
                showSaveAsInput: false,
                newSetName: "",
                activeView: tempId,
                originalColumns: [...this.state.activeColumns],
                hasUnsavedChanges: false,
            });
        }
    }

    handleUpdateView() {
        if (!this.state.activeView) return;
        
        const { t } = this.props;
        const set = this.props.columnsSets[this.state.activeView];
        if (!set) return;
        
        this.setState({ isSaving: true });
        // Actualizar set existente (usar ID y nombre)
        // onSaveColumnSet ahora devuelve una Promise, así que esperamos la respuesta
        const savePromise = this.props.onSaveColumnSet(this.state.activeView, set.name, this.state.activeColumns);
        
        if (savePromise && typeof savePromise.then === 'function') {
            savePromise
                .then(() => {
                    // El set se actualizó y se aplicó automáticamente
                    this.setState({
                        isSaving: false,
                        originalColumns: [...this.state.activeColumns],
                        hasUnsavedChanges: false,
                    });
                    // El alert se muestra desde Dashboard.js si hay error
                })
                .catch(() => {
                    // El error ya se maneja en Dashboard.js
                    this.setState({ isSaving: false });
                });
        } else {
            // Fallback para compatibilidad si onSaveColumnSet no devuelve una Promise
            alert(t('config_columns_modal.column_set_updated_successfully', 'Vista actualizada exitosamente'));
            this.setState({
                isSaving: false,
                originalColumns: [...this.state.activeColumns],
                hasUnsavedChanges: false,
            });
        }
    }

    handleSaveAsNew() {
        this.setState({ showSaveAsInput: true });
    }

    handleCancelSave() {
        this.setState({ 
            showSaveAsInput: false, 
            newSetName: "",
            savingError: null
        });
    }

    handleNewSetNameChange(event) {
        this.setState({ newSetName: event.target.value });
    }

    handleCopyColumnsLink() {
        const { t } = this.props;
        const url = encodeColumnsToUrl(this.state.activeColumns);
        navigator.clipboard.writeText(url).then(() => {
            toast.success(t('config_columns_modal.columns_link_copied'));
        });
    }

    toggleSection(sectionName) {
        this.setState(prevState => ({
            collapsedSections: {
                ...prevState.collapsedSections,
                [sectionName]: !prevState.collapsedSections[sectionName]
            }
        }));
    }

    getDataOfColumn(columnId) {
        const { t } = this.props;
        if(this.column_data_by_id[columnId] === undefined)
            this.column_data_by_id[columnId] = getColumnData(t, columnId);
        return this.column_data_by_id[columnId]
    }

    filterColumnsBySearch(columns) {
        if (!this.state.searchQuery.trim()) return columns;

        const query = this.state.searchQuery.toLowerCase();
        return columns.filter(columnId => {
            const columnData = this.getDataOfColumn(columnId);
            const title = columnData['title'] || '';
            const subtitle = columnData['subtitle'] || '';
            const searchText = `${title} ${subtitle}`.toLowerCase();
            return searchText.includes(query);
        });
    }

    renderFlexIndicatorsColumnSection() {
        const { t } = this.props;
        const editUrl = this.props.canEditFlexIndicators ? this._getEditFlexIndicatorsURL() : null;

        if(this.props.flexIndicators !== null && this.props.flexIndicators.length > 0) {
            return this.renderColumnSection(t('config_columns_modal.custom_columns'), this.props.flexIndicators, editUrl);
        }

        // Mostrar sección vacía con link para configurar
        const editLink = editUrl ? <a href={editUrl}><FaIcon iconName={"pencil-alt"}/></a> : "";
        return (
            <div key="custom-columns-empty" className="column-section-accordion">
                <div className="accordion-header">
                    <h3 className="form-title">
                        {t('config_columns_modal.custom_columns')}{editLink}
                    </h3>
                </div>
                <p className="text-muted" style={{fontSize: '0.85em', margin: '0.5em 0 1em'}}>
                    {t('config_columns_modal.no_custom_columns')}
                </p>
            </div>
        );
    }

    _getEditFlexIndicatorsURL() {
        return 'agency/flex-indicators'
    }

    renderPaidMediaColumnSection() {
        const { t } = this.props;
        const paidMediaIndicators = this.props.paidMediaIndicators !== null ? this.props.paidMediaIndicators : [];
        const thisPeriodIndicators = paidMediaIndicators.filter(id => !id.includes('Conversion Rate'));

        if(thisPeriodIndicators.length > 0) {
            return this.renderColumnSection(t('config_columns_modal.this_period'), thisPeriodIndicators, null);
        }
        return null;
    }

    getConversionRateIndicators() {
        const paidMediaIndicators = this.props.paidMediaIndicators || [];
        return paidMediaIndicators.filter(id => id.includes('Conversion Rate'));
    }

    renderGA4ColumnSection() {
        const flexIndicatorsWithGA4Metrics = this.getFlexIndicatorsWithGA4Metrics();
        const fixedGA4Indicators = this.props.ga4Indicators !== null ? this.props.ga4Indicators : [];
        const ga4Indicators = fixedGA4Indicators.concat(flexIndicatorsWithGA4Metrics);

        if((this.props.ga4Indicators !== null && this.props.ga4Indicators.length > 0) || flexIndicatorsWithGA4Metrics.length > 0) {
            return this.renderColumnSection('GA4', ga4Indicators, null);
        }
        return null;
    }

    getFlexIndicatorsWithGA4Metrics() {
        const columns = [];
        if (this.props.flexIndicators) {
            this.props.flexIndicators.forEach(columnId => {
                const columnData = this.getDataOfColumn(columnId);
                if(columnData["title"] && columnData["title"].includes("GA4"))
                    columns.push(columnId)
            });
        }
        return columns;
    }

    renderEcommerceColumnSection() {
        const flexIndicatorsWithEcommerceMetrics = this.getFlexIndicatorsWithEcommerceMetrics();
        const fixedEcommerceIndicators = (this.props.ecommerceIndicators != null) ? this.props.ecommerceIndicators : [];
        const ecommerceIndicators = fixedEcommerceIndicators.concat(flexIndicatorsWithEcommerceMetrics);

        if((this.props.ecommerceIndicators != null && this.props.ecommerceIndicators.length > 0) || flexIndicatorsWithEcommerceMetrics.length > 0) {
            return this.renderColumnSection('Ecommerce', ecommerceIndicators, null);
        }
        return null;
    }

    renderMetaColumnSection() {
        const metaIndicators = (this.props.metaIndicators != null) ? this.props.metaIndicators : [];
        if (metaIndicators.length === 0) {
            return null;
        }
        return this.renderColumnSection('Meta Ads', metaIndicators, null);
    }

    getFlexIndicatorsWithEcommerceMetrics() {
        const columns = [];
        if (this.props.flexIndicators) {
            this.props.flexIndicators.forEach(columnId => {
                const columnData = this.getDataOfColumn(columnId);
                if(columnData["metricName"] && columnData["metricName"].toLowerCase().includes("ecommerce")) {
                    columns.push(columnId);
                }
            });
        }
        return columns;
    }

    renderColumnSection(name, columns, urlToEdit) {
        const { t } = this.props;
        const filteredColumns = this.filterColumnsBySearch(columns);
        if (filteredColumns.length === 0 && this.state.searchQuery.trim()) {
            return null;
        }

        const isCollapsed = this.state.collapsedSections[name] || false;
        const editLink = urlToEdit ? <a href={urlToEdit}><FaIcon iconName={"pencil-alt"}/></a> : "";

        return (
            <div key={name} className="column-section-accordion">
                <div 
                    className="accordion-header" 
                    onClick={() => this.toggleSection(name)}
                >
                    <h3 className="form-title">
                        {name}{editLink}
                    </h3>
                    <FaIcon 
                        iconName="chevron-right" 
                        className={isCollapsed ? "accordion-chevron collapsed" : "accordion-chevron expanded"}
                    />
                </div>
                {!isCollapsed && (
                    <div className="form-grid row-col-2">
                        {filteredColumns.map(columnId =>
                            this.renderColumnChoice(name, columnId)
                        )}
                    </div>
                )}
            </div>
        );
    }

    renderColumnChoice(section, columnId) {
        const columnData = this.getDataOfColumn(columnId);
        const isChecked = this.state.activeColumns.includes(columnId);

        return (
            <div key={columnId} className="form-item -inline">
                <Switch checked={isChecked}
                        name={columnId}
                        onChange={this.handleChange}/>
                <div className="combined-label">
                    <p className="combined-label-title">{(section.includes("GA4")? columnData['title'].replace(" (GA4)", ""): section.includes("Ecommerce")? columnData['title'].replace(" (Ecommerce)", ""): columnData['title'])}</p>
                    <p className="combined-label-subtitle">{columnData['subtitle']}</p>
                </div>
            </div>
        )
    }

    render() {
        const { t } = this.props;
        // columnsSets es un objeto donde las claves son los IDs de los sets
        // Filtrar el set "UNNAMED_UNSAVED_COLUMNS_SET" para no mostrarlo
        const columnsSetsKeys = Object.keys(this.props.columnsSets || {}).filter(setId => {
            const set = this.props.columnsSets[setId];
            return set && set.name !== 'UNNAMED_UNSAVED_COLUMNS_SET';
        });
        const totalSelected = this.state.activeColumns.length;
        const activeViewName = this.state.activeView || "custom";

        const viewSets = columnsSetsKeys.map(setId => {
            const set = this.props.columnsSets[setId];
            if (!set) return null;
            const displayName = this.state.activeView === setId && this.state.hasUnsavedChanges 
                ? `${set.name} *` 
                : set.name;
            return {
                id: setId,
                name: set.name,
                displayName
            };
        }).filter(Boolean);

        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.onClose} className="columns-selector-modal dashboard-column-config-modal" size="lg">
                <ModalHeader toggle={this.props.onClose} className="columns-selector-modal__header">
                    <FaIcon iconName="columns"/>
                    {t('config_columns_modal.title')}
                </ModalHeader>
                <ModalBody className="columns-selector-modal__body">
                    {renderSearchBar({
                        searchQuery: this.state.searchQuery,
                        placeholder: t('config_columns_modal.search_placeholder', 'Buscar dimensiones o métricas...'),
                        onSearchChange: this.handleSearchChange
                    })}

                    <div className="columns-selector-modal__panels-container">
                        {/* Panel Izquierdo: Columnas Disponibles */}
                        <div className="columns-selector-modal__left-panel">
                            <h3 className="columns-selector-modal__panel-title">
                                {t('config_columns_modal.available_columns', 'Columnas Disponibles')}
                            </h3>
                            {this.renderColumnSection(t('config_columns_modal.goals'), [GOAL_1_INFO_COLUMN, GOAL_1_COLUMN, GOAL_2_INFO_COLUMN, GOAL_2_COLUMN], null)}
                            {this.renderFlexIndicatorsColumnSection()}
                            {this.renderPaidMediaColumnSection()}
                            {this.renderColumnSection(t('config_columns_modal.today'), NAMES_FOR_TODAY_COLUMNS_SECTIONS, null)}
                            {this.renderColumnSection(t('config_columns_modal.budget'), NAMES_FOR_BUDGET_COLUMNS_SECTIONS, null)}
                            {this.renderColumnSection(t('config_columns_modal.conversions'), NAMES_FOR_CONVERSIONS_COLUMNS_SECTIONS.concat(this.getConversionRateIndicators()), null)}
                            {this.renderColumnSection(t('config_columns_modal.available_funds'), NAMES_FOR_FUNDS_COLUMN_SECTIONS, null)}
                            {this.renderGA4ColumnSection()}
                            {this.renderEcommerceColumnSection()}
                            {this.renderMetaColumnSection()}
                            {this.renderColumnSection(t('config_columns_modal.attributes'), [CURRENT_PERIOD_PERIOD_DATES_COLUMN, CURRENCY_COLUMN, CURRENT_PERIOD_TIME_COMPLETION_COLUMN, CAMPAIGN_STATUS_COLUMN, LABELS_COLUMN, COMMENTS_COLUMN], null)}
                        </div>

                        {/* Panel Derecho: Columnas Seleccionadas */}
                        <div className="columns-selector-modal__right-panel">
                            <h3 className="columns-selector-modal__panel-title">
                                {t('config_columns_modal.selected_columns', 'Columnas Seleccionadas')} ({totalSelected})
                                {totalSelected > 0 && (
                                    <button
                                        className="btn-icon-link"
                                        onClick={this.handleCopyColumnsLink}
                                        title={t('config_columns_modal.copy_columns_link')}
                                    >
                                        <FaIcon iconName="link"/>
                                    </button>
                                )}
                            </h3>
                            {totalSelected === 0 ? (
                                <div className="columns-selector-modal__empty-message">
                                    <p>{t('config_columns_modal.select_columns_message', 'Selecciona columnas del panel izquierdo para empezar a construir tu vista.')}</p>
                                </div>
                            ) : (
                                <ActiveColumnsList
                                    activeColumns={this.state.activeColumns}
                                    onColumnsPositionChange={this.handleColumnsPositionChange}
                                    getColumnData={this.getDataOfColumn.bind(this)}
                                    onColumnRemove={this.handleColumnRemove}
                                />
                            )}
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter className="columns-selector-modal__footer">
                    {renderViewSelector({
                        activeViewId: activeViewName,
                        viewSets,
                        viewSelectorLabel: t('config_columns_modal.current_view', 'Set de columnas'),
                        customViewLabel: t('config_columns_modal.custom_view', 'Set sin guardar'),
                        saveAsNewLabel: t('config_columns_modal.save_as_new', 'Guardar Nuevo'),
                        saveViewLabel: t('config_columns_modal.save_view', 'Guardar'),
                        updateViewLabel: t('config_columns_modal.update_view', 'Actualizar Set'),
                        hasActiveView: !!this.state.activeView,
                        hasUnsavedChanges: this.state.hasUnsavedChanges,
                        showSaveAsInput: this.state.showSaveAsInput,
                        newSetName: this.state.newSetName,
                        isSaving: this.state.isSaving,
                        setNamePlaceholder: t('config_columns_modal.set_name_placeholder', 'Nombre del set'),
                        onViewSelect: this.handleViewSelect,
                        onSaveAsNew: this.handleSaveAsNew,
                        onSaveView: this.handleSaveView,
                        onUpdateView: this.handleUpdateView,
                        onNameChange: this.handleNewSetNameChange,
                        onCancel: this.handleCancelSave,
                        t
                    })}

                    {renderActionButtons({
                        hasActiveView: !!this.state.activeView,
                        hasUnsavedChanges: this.state.hasUnsavedChanges,
                        showSaveAsInput: this.state.showSaveAsInput,
                        newSetName: this.state.newSetName,
                        isSaving: this.state.isSaving,
                        saveViewLabel: t('config_columns_modal.save_view', 'Guardar'),
                        updateViewLabel: t('config_columns_modal.update_view', 'Actualizar Set'),
                        setNamePlaceholder: t('config_columns_modal.set_name_placeholder', 'Nombre del set'),
                        onSaveAsNew: this.handleSaveAsNew,
                        onSaveView: this.handleSaveView,
                        onUpdateView: this.handleUpdateView,
                        onApply: this.handleApply,
                        onClose: this.props.onClose,
                        onNameChange: this.handleNewSetNameChange,
                        t
                    })}
                </ModalFooter>
            </Modal>
        );
    }
}

export const ConfigColumnsModal = withTranslation()(ConfigColumnsModalComponent);

